ListItem = createReactClass
  render: ->
    <li {...@props}>{@props.text}</li>

module.exports = ListItem
